class BannerNumber {
  private section: HTMLElement | null;
  private animated: boolean = false;

  constructor() {
    this.section = document.getElementById('banner-number');
    if (this.section) {
      this._init();
    }
  }

  _init() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.animated) {
            this.animateNumbers();
            this.animated = true;
            if (this.section) {
              observer.unobserve(this.section);
            }
          }
        });
      },
      { threshold: 0.1 }
    );

    if (this.section) {
      observer.observe(this.section);
    }
  }

  animateNumbers() {
    const numberElements = this.section?.querySelectorAll<HTMLElement>(
      '.banner-number__column-number'
    );
    if (!numberElements) return;

    numberElements.forEach((element) => {
      const finalNumber = parseInt(element.textContent || '0', 10);
      if (isNaN(finalNumber)) return;

      const duration = 2000; // 2.5 seconds
      let startTime: number | null = null;

      const animation = (currentTime: number) => {
        if (startTime === null) {
          startTime = currentTime;
        }
        const elapsedTime = currentTime - startTime;
        const progress = Math.min(elapsedTime / duration, 1);
        const currentValue = Math.floor(progress * finalNumber);

        element.textContent = currentValue.toString();

        if (progress < 1) {
          requestAnimationFrame(animation);
        } else {
          element.textContent = finalNumber.toString();
        }
      };

      requestAnimationFrame(animation);
    });
  }
}
export const bannerNumber = new BannerNumber();
